var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class HallResearchSw {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: 'PW',
                next: /PW[01]/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send('FW', /FW[\s:]*(?:Version:)?([\d\.]+)/i, tags);
                return match[1];
            }),
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`PW`, /PW(\d)/i, tags);
                return match[1] === '1';
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`PW${power ? '1' : '0'}`, /PW(\d)/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 4000);
                this.framework.suspend(3000);
                return match[1] === '1';
                return this.state.power.value;
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`CO${key}`, /CO(\d+),(\d+)/i, tags);
                return match[2];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                // Command format is CVoutput, input
                const match = yield this.socket.send(`CO${key},${value}`, /CO(\d+),(\d+)/i, tags);
                return match[2];
            }),
            powerOffRestrictions: ['set', 'get'],
        };
        // polling
        this.polls = [
            { intervalMs: 2500, controls: ['videoMatrixRoutes'] },
            { intervalMs: 4000, controls: ['power'] },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
HallResearchSw.driverType = 'socketDriver';
HallResearchSw.key = '-LSti3Qq6rZRICq5sFI0';
HallResearchSw.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r',
};
HallResearchSw.socketOptions = [
    Object.assign(Object.assign({}, HallResearchSw.baseSocketOptions), { port: 23 }),
    Object.assign(Object.assign({}, HallResearchSw.baseSocketOptions), { port: 4999 }),
];
